import React from 'react';
import WelcomePage from './WelcomePage'
import UserGrid from './components/UserGrid'
import GalleryGrid from './components/GalleryGrid'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './header'
import Footer from './Footer'
import ChecklistView from './components/checklistView'
import './App.css';
import SetView from './components/SetView';
const App = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Header/>
        <Switch>
          <Route exact path="/">
           <WelcomePage/>
          </Route>
          <Route path="/mygrid">
            <UserGrid/>
          </Route>
          <Route path="/gallery">
            <GalleryGrid/>
          </Route>
          <Route path="/checklistView">
            <ChecklistView/>
          </Route>
          <Route path="/setView">
            <SetView/>
          </Route>
        </Switch>
        <Footer/>
      </BrowserRouter> 
    </div>
   
  );
}

export default App;
